import actionTypes from '@atom/actions/actionTypes';

import initialState from './initialState';

export default function arcgisLayerData(
  state = initialState.arcgisLayerData,
  action,
) {
  const { data, type } = action;
  switch (type) {
    case actionTypes.SET_ARCGIS_LAYER_DATA: {
      return {
        ...state,
        [data.id]: { ...state[data.id], ...data.layerData },
      };
    }
    case actionTypes.REMOVE_ARCGIS_LAYER_DATA: {
      return Object.fromEntries(
        Object.entries(state).filter(([id]) => id !== data.id),
      );
    }
    default: {
      return state;
    }
  }
}
